import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import Filters from './Filters'
import Results from './Results'

import MetaTags from 'react-meta-tags';

import "bootstrap/dist/css/bootstrap.min.css";
import '../css/static_pages.css'

import { HOST, API_URL } from '../auxiliar/constants'

class CardsMain extends Component {

    state = {
        loading: true,
        filteringResults: false,
        results: [],
        filteredResults: [],
        habitats: [],
        taxonomies: [],
        eicatCategories: [],
        invasaquaLists: [],
        sibicEasinRelations: []
    }

    async refreshEnvironments(){

        let habitats = []
        let eicatCategories = []
        let invasaquaLists = []

        await fetch(`https://eei.sibic.org/API/invasaqua.php?function=getHabitats&lang=${this.props.i18n.language}`)
            .then(response => response.json())
            .then(data => {
                habitats = data
            })
        await fetch(`https://eei.sibic.org/API/invasaqua.php?function=getEicatCategories&lang=${this.props.i18n.language}`)
            .then(response => response.json())
            .then(data => {
                eicatCategories = data
            })

        await fetch(`https://eei.sibic.org/API/invasaqua.php?function=getInvasaquaLists&lang=${this.props.i18n.language}`)
            .then(response => response.json())
            .then(data => {
                invasaquaLists = data
            })
        this.setState({
            habitats,
            eicatCategories,
            invasaquaLists
        })
    }

    componentDidMount() {
        this.fetchEspecies()
        i18next.on('languageChanged', () => {this.refreshEnvironments()})
    }

    applyFilters = (filters) => {
        this.setState({
            filteringResults: true
        })
        this.fetchFilteredIds(filters)
    }

    async fetchFilteredIds(filters){

        if (
        filters.scientificName === "" &&
        filters.commonName === "" &&
        filters.selectedTaxonomy === "" &&
        filters.selectedEicat === "" &&
        filters.selectedHabitats.length === 0 &&
        filters.selectedInvasaquaLists.length === 0
        ) {
            this.setState({
                filteredResults: this.state.results
            })
            setTimeout(() => this.setState({
                filteringResults: false
            }),600)

        } else {

            let filtObj = {
                function: 'getSibicFilter',
                spe: filters.scientificName,
                tax: filters.selectedTaxonomy,
                com: filters.commonName,
                hab: filters.selectedHabitats,
                eic: filters.selectedEicat,
                inv: filters.selectedInvasaquaLists
            }

            let params = new URLSearchParams(filtObj)
            let toRemove = []
            params.forEach((v, k) => {
              if (!v) {
                  toRemove.push(k)
              }
            })
            toRemove.forEach(k => params.delete(k))

            console.log(`https://eei.sibic.org/API/invasaqua.php?${params.toString()}`)

            let ids = []
            await fetch(`https://eei.sibic.org/API/invasaqua.php?${params.toString()}`)
                .then(response => response.json())
                .then(data => {
                    ids = data.map(spec => spec.species_id)
                })

                this.setState({
                    filteredResults: ids.length > 0 ? this.state.results.filter(r => ids.indexOf(r.species_id) !== -1) : []
                })
                setTimeout(() => this.setState({
                    filteringResults: false
                }),600)
        }
    }

    async fetchEspecies() {
        let results = []
        let habitats = []
        let taxonomies = []
        let eicatCategories = []
        let invasaquaLists = []
        let sibicEasinRelations = []

        await fetch('https://eei.sibic.org/API/invasaqua.php?function=getSpecies')
            .then(response => response.json())
            .then(data => {
                results = data.species
            })

        await fetch(`https://eei.sibic.org/API/invasaqua.php?function=getHabitats&lang=${this.props.i18n.language}`)
            .then(response => response.json())
            .then(data => {
                habitats = data
            })
        await fetch('https://eei.sibic.org/API/invasaqua.php?function=getTaxonomicGroup')
            .then(response => response.json())
            .then(data => {
                taxonomies = data
            })

        await fetch(`https://eei.sibic.org/API/invasaqua.php?function=getEicatCategories&lang=${this.props.i18n.language}`)
            .then(response => response.json())
            .then(data => {
                eicatCategories = data
            })

        await fetch(`https://eei.sibic.org/API/invasaqua.php?function=getInvasaquaLists&lang=${this.props.i18n.language}`)
            .then(response => response.json())
            .then(data => {
                invasaquaLists = data
            })

        await fetch(`${HOST}${API_URL}/?function=getRelations`)
            .then(response => response.json())
            .then(data => {
                sibicEasinRelations = data
            })

        this.setState({
            results,
            habitats,
            taxonomies,
            eicatCategories,
            invasaquaLists,
            sibicEasinRelations,
            filteredResults: results,
            loading: false
        })
    }

    render() {
        const { t } = this.props
        return (
            <div className="container-fluid container_page container_CardsMain">
                <MetaTags>
                    <title>{t("title-fichas")}</title>
                    <meta name="description" content={t("description-fichas")} />
                </MetaTags>
                <div className="row">
                    <Filters filteringResults={this.state.filteringResults} loading={this.state.loading} onFilter={this.applyFilters} invasaquaLists={this.state.invasaquaLists} eicatCategories={this.state.eicatCategories} habitats={this.state.habitats} taxonomies={this.state.taxonomies} />
                    <Results results={this.state.filteredResults} loading={this.state.loading || this.state.filteringResults} relations={this.state.sibicEasinRelations} invasaquaLists={this.state.invasaquaLists} eicatCategories={this.state.eicatCategories}/>
                </div>
            </div>
        );
    }
}

export default withTranslation()(CardsMain);
